import { type CSSProperties } from "react";

export const containerStyle: CSSProperties = {
  zIndex: 999,
  position: "sticky",
  bottom: "24px",
  display: "flex",
  justifyContent: "center",
  pointerEvents: "none",
};

export const componentStyle: CSSProperties = {
  display: "flex",
  alignItems: "center",
  background: "white",
  pointerEvents: "auto",
};

export const contentStyle: CSSProperties = {
  display: "flex",
  alignItems: "center",
  background: "white",
  pointerEvents: "auto",
  overflow: "hidden",
};

export const dividerStyle: CSSProperties = {
  borderInlineStart: "1px solid #884EA6",
  height: "24px",
  margin: "0 6px",
};

export const tagStyle: CSSProperties = {
  background: "#E0DFFF",
  color: "#884EA6",
  borderRadius: 16,
  padding: "4px 8px",
};

export const fullWidth: CSSProperties = {
  width: "100%",
};

export const pageTitle: CSSProperties = {
  color: "#884EA6",
  margin: 0,
};

export const gradientBackground: CSSProperties = {
  backgroundImage: `linear-gradient(137deg, #e5f4ff 0%, #efe7ff 100%)`,
};

export const gradientBackgroundWelcome: CSSProperties = {
  backgroundImage: `linear-gradient(90.9deg, #E6F4FF 0%, #F9F0FF 100%)`,
  boxShadow:
    "0px 3px 8px rgba(131, 126, 255, 0.25), 0px 1px 3px rgba(131, 126, 255, 0.25), inset 0px 1px 0px rgba(131, 126, 255, 0.08), inset 0px 0px 1px rgba(131, 126, 255, 0.3)",
  borderRadius: "16px",
};
